import { useInitPage } from 'hooks/useInitPage';

export const PageContainer = ({ children, location }) => {
  useInitPage(location.pathname);

  return children;
};
